<template>
  <div id="app">
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component" />
      </keep-alive>
    </router-view>
  </div>
</template>

<script setup lang="ts"></script>

<style>
body {
  font-size: 16px;
  background-color: #f2f3f5;
  -webkit-font-smoothing: antialiased;
}
</style>
